import React, { useEffect } from 'react';
import { isValidIP, browser } from '@/utils/utils';
import axios from 'axios';
import styled from 'styled-components';
import lxLogo from '@/img/lxLogo.png';
import wxLogo from '@/img/wxLogo.png';
import { message } from 'antd';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import { hrefChangeUrl } from "@/utils/utils";

const Wrapper = styled.div`
  background: #ffffff;
  box-shadow: 0px 1px 0px 0px #e5e5e5;
  height: 100vh;
  width: 100vw;
  max-width: 375px;
  margin: 0 auto;
  padding-top: 80px;
  .flex {
    display: flex;
    align-items: center;
  }
`;

const GuideBox = styled.div`
  margin: 0 auto;
  width: max-content;
  img {
    width: 50px;
  }
  .line {
    width: 6px;
    height: 6px;
    background: #e5e5e5;
    border-radius: 50%;
    margin: 0 50px;
    position: relative;
    &:before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      background: #e5e5e5;
      border-radius: 50%;
      position: absolute;
      left: -20px;
      top: -1px;
    }
    &:after {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      background: #e5e5e5;
      border-radius: 50%;
      position: absolute;
      right: -15px;
      top: 1px;
    }
  }
`;

const DescBox = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  margin-top: 30px;
  text-align: center;
`;

const FunctionBox = styled.div`
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin-top: 100px;
  margin-left: 50px;
  > div {
    color: #333333;
    margin-top: 8px;
  }
`;

const PcBox = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default function QrcodeView() {
  const hash = location.hash.replace('#/', '');
  const isLocal = isValidIP(window.location.hostname);
  const origin = isLocal ? process.env.SERVER_DOMAIN : location.origin;
  const [url, inviteCodeId, type] = hash.split('/');
  const isMobile = browser(window.navigator.userAgent);
  const [link, setLink] = useState('');

  const getLink = () => {
    if (!inviteCodeId || !type) {
      return;
    }
    axios
      .post(`${origin}/api/marketing-tool/applet/shortLink/get`, {
        inviteCodeId,
        type,
      })
      .then((res) => {
        const data = res?.data || {};
        if (data?.code === 0) {
          const shortLink = data?.data?.shortLink || '';
          if (!shortLink) {
            message.error(`获取短链失败${data?.requestId}`);
            return;
          }
          setLink(shortLink);
          // location.href = shortLink;
          hrefChangeUrl(shortLink);
          
        } else {
          message.error(data?.message || 'request error');
        }
      })
      .catch((err) => {
        message.error(err?.message);
      });
  };

  const openApp = (url) => {
    if (!url) {
      return;
    }
    // location.href = url;
    hrefChangeUrl(url);
    
  };

  const copyFn = () => {
    copy(link);
    message.success('复制成功');
  };

  useEffect(() => {
    getLink();
  }, []);
  return (
    <Wrapper>
      {isMobile ? (
        <>
          <GuideBox>
            <div className='flex'>
              <img src={lxLogo} />
              <div className='line' />
              <img src={wxLogo} />
            </div>
          </GuideBox>
          <DescBox>正在前往微信获取小程序信息…</DescBox>
          <FunctionBox>
            若小程序跳转失败，请尝试以下方法：
            <div>
              1、未自动跳转请尝试点击此按钮
              <a onClick={() => openApp(link)}>打开小程序</a>
            </div>
            <div>
              2、<a onClick={copyFn}>复制链接</a>并在微信中打开
            </div>
          </FunctionBox>
        </>
      ) : (
        <PcBox>请在手机打开网页链接</PcBox>
      )}
    </Wrapper>
  );
}
